import { CustomerGroupType } from '@navio/nsdk';
import { CUSTOMERS_LIST_TAB_DEFAULT, CustomersListTab, commonTexts } from 'noddi-util';

export type CustomersListTexts = {
  personalCustomers: string;
  organizations: string;
  groups: string;
};

export const defaultCustomersListTexts: CustomersListTexts = commonTexts.customersList;

/** API `types` filter for a list tab. Each tab is one customer type. */
export const getCustomerGroupTypesForListTab = (tab: CustomersListTab): CustomerGroupType[] => {
  switch (tab) {
    case CustomersListTab.PERSONAL:
      return [CustomerGroupType.PERSONAL];
    case CustomersListTab.ORGANIZATIONS:
      return [CustomerGroupType.ORGANIZATION];
    case CustomersListTab.GROUPS:
      return [CustomerGroupType.GROUP];
  }
};

export const resolveCustomersListTab = (tab: string | null): CustomersListTab =>
  tab === CustomersListTab.ORGANIZATIONS || tab === CustomersListTab.GROUPS ? tab : CUSTOMERS_LIST_TAB_DEFAULT;

/** A different dataset starts at page one while keeping the search and tenant scope. */
export const customerTabSearchParams = (params: URLSearchParams, tab: CustomersListTab): URLSearchParams => {
  const next = new URLSearchParams(params);
  next.set('tab', tab);
  next.delete('page');
  return next;
};
